import debounce from 'just-debounce';

/**
 * @class HeaderPassword
 * @classdesc The header section is used to handle the header functionality.
 *
 * @extends Core.SectionComponent
 */
export default class HeaderPassword extends Core.SectionComponent {
  constructor(el, context) {
    super(el, context);
    this.header = this.el.querySelector('[data-header-password]');
    this.sticky = this.data.settings.sticky;
    this.showBorder = this.data.settings.show_border;

    this.events.register(document, 'cart:update', e => {
      this._updateCartCount(e.detail.count);
    });

    if (this.sticky && this.showBorder === false) {
      this.events.register(document, 'scroll', debounce(() => { this._setStickyShadow(); }, 100, false, true));
    }
  }

  /**
   * On mount, we create the event listeners for the header section.
   */
  onMount() {
    const drawerFragment = this.el.querySelector('[data-drawer]').content.cloneNode(true);
    const { el: embedModalBtnEl } = this.query('button', 'login');
    const drawerModal = Core.Components.getComponent('drawer-modal');

    if (!drawerModal) return;

    this.drawerFlyout = drawerModal.createFlyout(drawerFragment);
    this.drawerFlyout
      .then(drawerFlyout => {
        if (!drawerFlyout) return;

        if (this.data.password_error) {
          drawerFlyout.populateContent(drawerFragment);
          drawerModal.openFlyout(drawerFlyout, embedModalBtnEl);

          this.events.register(drawerFlyout.el, 'header-password-drawer:close', () => drawerModal.closeFlyout(drawerFlyout));
        }

        this.events.register(embedModalBtnEl, 'click', e => {
          e.stopPropagation();
          e.preventDefault();

          drawerFlyout.populateContent(drawerFragment);
          drawerModal.openFlyout(drawerFlyout, embedModalBtnEl);

          this.events.register(drawerFlyout.el, 'header-password-drawer:close', () => drawerModal.closeFlyout(drawerFlyout));
        });
      });

    this.headerToolbar = this.query('header-tool-bar');

    this._setHeightVariables();
    this.events.register(window, 'resize', debounce(() => this._setHeightVariables(), 100));
  }

  onDismount() {
    super.onDismount();

    if (this.drawerFlyout) {
      this.drawerFlyout.then(drawerFlyout => drawerFlyout.destroy());
    }
  }

  /**
   * Updates the sticky header logic
   *
   * @private
   */
  _setHeightVariables() {
    this.headerSection = document.querySelector('#shopify-section-header-password');

    if (this.headerToolbar) {
      this.headerToolbarHeight = this.headerToolbar.getHeight();
      this.headerSection.style.setProperty('--announcement-height', `${this.headerToolbarHeight}px`);
    }

    const headerHeight = this.header.getBoundingClientRect().height;
    this.headerSection.style.setProperty('--header-height', `${headerHeight}px`);
  }

  /**
   * Checks the scroll position and sets the sticky shadow
   *
   * @private
   */
  _setStickyShadow() {
    if (window.scrollY > 100) {
      this.header.classList.add('header--shadow');
    } else {
      this.header.classList.remove('header--shadow');
    }
  }
}
